import { r as A, c as L } from "./utilities-D-QcnR4L.js";
class q extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const e = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(e instanceof HTMLTemplateElement)) return;
      (this.attachShadow({ mode: "open" }).append(e.content.cloneNode(!0)), e.remove());
    }
  }
}
class S extends Error {
  constructor(e, n) {
    super(`Required ref "${e}" not found in component ${n.tagName.toLowerCase()}`);
  }
}
class m extends q {
  refs = {};
  requiredRefs;
  observeRefChanges = !1;
  #e;
  #t;
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }
  get signal() {
    return (this.#e || (this.#e = new AbortController()), this.#e.signal);
  }
  connectedCallback() {
    (super.connectedCallback(),
      x(),
      this.#r(),
      this.observeRefChanges &&
        (this.#t = A(() => {
          if (this.isConnected)
            for (const e of this.roots)
              this.#n.observe(e, {
                childList: !0,
                subtree: !0,
                attributes: !0,
                attributeFilter: ["ref"],
                attributeOldValue: !0,
              });
        })));
  }
  updatedCallback() {
    (this.#n.takeRecords(), this.#r());
  }
  disconnectedCallback() {
    (this.#t !== void 0 && (L(this.#t), (this.#t = void 0)),
      this.#n.disconnect(),
      this.#e?.abort(),
      (this.#e = void 0));
  }
  #r() {
    const e = {},
      n = this.roots.reduce((s, r) => {
        for (const o of r.querySelectorAll("[ref]")) this.#s(o) && s.add(o);
        return s;
      }, new Set());
    for (const s of n) {
      const r = s.getAttribute("ref") ?? "",
        o = r.endsWith("[]"),
        i = o ? r.slice(0, -2) : r;
      if (o) {
        const a = Array.isArray(e[i]) ? e[i] : [];
        (a.push(s), (e[i] = a));
      } else e[i] = s;
    }
    if (this.requiredRefs?.length) {
      for (const s of this.requiredRefs) if (!(s in e)) throw new S(s, this);
    }
    this.refs = e;
  }
  #n = new MutationObserver((e) => {
    e.some(
      (n) =>
        (n.type === "attributes" && this.#s(n.target)) ||
        (n.type === "childList" && [...n.addedNodes, ...n.removedNodes].some(this.#s))
    ) && this.#r();
  });
  #s = (e) => h(E(e)) === this;
}
function E(t) {
  if (t.parentNode) return t.parentNode;
  const e = t.getRootNode();
  return e instanceof ShadowRoot ? e.host : null;
}
function h(t) {
  if (!t) return null;
  if (
    t instanceof m ||
    (t instanceof HTMLElement && t.tagName.toLowerCase().endsWith("-component"))
  )
    return t;
  const e = E(t);
  return e ? h(e) : null;
}
let N = !1;
function x() {
  if (N) return;
  N = !0;
  const t = [
      "click",
      "change",
      "select",
      "focus",
      "blur",
      "submit",
      "input",
      "keydown",
      "keyup",
      "toggle",
    ],
    e = ["focus", "blur"],
    n = ["pointerenter", "pointerleave"];
  for (const r of [...t, ...n]) {
    const o = `on:${r}`;
    document.addEventListener(
      r,
      (i) => {
        const a = s(i);
        if (!a) return;
        const v =
            i.target !== a
              ? new Proxy(i, {
                  get(c, R) {
                    if (R === "target") return a;
                    const p = Reflect.get(c, R);
                    return typeof p == "function" ? p.bind(c) : p;
                  },
                })
              : i,
          b = a.getAttribute(o) ?? "",
          g = b.split("/"),
          l = g[0];
        let u = g[1];
        const y = b.match(/([\/\?][^\/\?]+)([\/\?][^\/\?]+)$/),
          w = y ? y[2] : null,
          f = l && l !== "" ? (l.startsWith("#") ? document.querySelector(l) : a.closest(l)) : h(a);
        if (!f || !u) return;
        const d = f instanceof m ? f : h(f);
        if (!d || !(d instanceof m) || !u) return;
        u = u.replace(/\?.*/, "");
        const C = d[u];
        if (typeof C == "function")
          try {
            const c = [v];
            (w && c.unshift($(w)), C.call(d, ...c));
          } catch (c) {
            console.error(c);
          }
      },
      { capture: !0 }
    );
  }
  function s(r) {
    const o = r.composedPath?.()[0] ?? r.target;
    if (o instanceof Element)
      return o.hasAttribute(`on:${r.type}`)
        ? o
        : n.includes(r.type)
          ? null
          : r.bubbles || e.includes(r.type)
            ? o.closest(`[on\\:${r.type}]`)
            : null;
  }
}
function $(t) {
  const e = t[0],
    n = t.slice(1);
  return e === "?"
    ? Object.fromEntries(Array.from(new URLSearchParams(n).entries()).map(([s, r]) => [s, k(r)]))
    : k(n);
}
function k(t) {
  if (t === "true") return !0;
  if (t === "false") return !1;
  const e = Number(t);
  return !isNaN(e) && t.trim() !== "" ? e : t;
}
export { m as C };
